define('LocalStorage',['backbone','underscore','site_vars'],function(Backbone,_,site_vars){
    //
    // prototype LocalStorage
    //
    var ls;
    try {
        ls = window.localStorage;
    }catch(err){
        ls = [];
        ls.clear = function(){};
        ls.removeItem = function(){};
        ls.setItem = function(){};
        ls.getItem = function(){return};
        ls.key = function(){};
    }

    var LocalStoragePrototype = {
        afterInitialize:{
          localStorageSetup:'localStorageSetup'
        },
        localStorageSetup:function(){
            this.isRemoteFetching = false;
            this.on('sync',this.onRemoteFetch,this);
        },
        getLocalStorageKey:function(){
            var key = this.name;
            if(this.country_based){
                key += '_'+site_vars.country_code;
            }
            if(this.translated){
                key += '_'+this.getLangIsoCode();
            }
            if(this.id){
                key += '_'+this.id;
            }
            return key;
        },
        getLocalStorageKeyExpires:function(){
            return this.getLocalStorageKey()+'_expires';
        },
        getExpiresFromXHR:function(xhr){
            var Expires = '0';
            try{
                Expires = xhr.getResponseHeader('Expires') || '0';
            }catch(err){
            }
            return Expires;
        },
        onRemoteFetch:function (ressource,response,promise) {
            var self = this;
            self.isRemoteFetching = false;
            if(promise && promise.xhr) {
                promise.xhr.done(function(data, textStatus, jqXHR){
                    self.setLocalStorageItem(self.toJSON(),self.getExpiresFromXHR(jqXHR));
                })
            }
        },
        softFetch:function(){
            // effectue une mise à jour des données à partir du localStorage sans notion d'expiration
            // utilisé au démarrage pour ne pas perdre des données qui sont sensées être expirées,
            // mais qui n'existe pas server side
            // le fetch classique (remote ou local) ne supprimera pas ces données si elles sont absentes
            try {
                var item = ls.getItem(this.getLocalStorageKey()), dataSet = JSON.parse(item);
                if (dataSet) {
                    dataSet = _.defaults(this.toJSON(), dataSet);
                    this.set(dataSet);
                }
            }catch(err) {
                // cas où le localStorage n'est pas opérationnel
            }
        },
        localFetch:function(){
            try{
                var self = this,
                    expiresKey = self.getLocalStorageKeyExpires(),
                    expires = ls.getItem(expiresKey),
                    itemKey = self.getLocalStorageKey(),
                    item = ls.getItem(itemKey),
                    expirationDelay = expires == '0' ? -1 : new Date(expires).getTime() - new Date().getTime();
                // TODO : expires managment, with XHR Header Expires
                if(expirationDelay<0){
                    self.resetLocalStorageItem();
                }else if(!_.isUndefined(item)){
                    var dataSet = JSON.parse(item);
                    if(dataSet){
                        self.set(dataSet);
                        self.trigger('sync',self,dataSet);
                        return true;
                    }
                }
            }catch(err){
                // cas où le localStorage n'est pas opérationnel
                return false;
            }
            return false;
        },
        remoteFetch:function(options){
            this.isRemoteFetching = true;
            switch (this.backbonePattern) {
                case 'Model' :
                    return Backbone.Model.prototype.fetch.call(this, options);
                    break;
                case 'Collection' :
                    return Backbone.Collection.prototype.fetch.call(this, options);
                    break;
            }
        },
        localAndRemoteFetch:function(){
            this.localFetch();
            this.remoteFetch();
        },
        resetLocalStorageItem:function(){
            try {
                ls.removeItem(this.getLocalStorageKey());
                ls.removeItem(this.getLocalStorageKeyExpires());
            }catch(err){
            }
        },
        setLocalStorageItem:function(json,expires){
            if(!expires){
                expires = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toString();
            }
            if(!json){
                json = this.toJSON();
            }
            try {
                ls.setItem(this.getLocalStorageKeyExpires(), expires);
            }catch(err){
                this.trigger('QuotaExceededError',this.name);
            }
            this.updateLocalStorageItem(json);
        },
        updateLocalStorageItem:function(json){
            if(!json){
                json = this.toJSON();
            }
            try {
                ls.setItem(this.getLocalStorageKey(), JSON.stringify(json));
            }catch(err){
                this.trigger('QuotaExceededError',this.name);
            }
        },
        fetch:function(){
            //
            //
            if(!this.localFetch()){
                // if model isn't currently fetching remote
                if(!this.isRemoteFetching){
                    this.remoteFetch();
                }
            }
            //
        }
    };

    // static function
    LocalStoragePrototype.removeAllItemsOfType = function(type){
        var exp = new RegExp('^'+type+'.*');
        try {
            for (var i = 0; i < ls.length; i++) {
                var key = ls.key(i);
                if (exp.test(key)) {
                    ls.removeItem(key);
                    i--;
                }
            }
        }catch(err){
        }
    };

    //
    // list utils
    //
    function getList(key){
        return JSON.parse(ls.getItem(key)) || [];
    };
    LocalStoragePrototype.getList = getList;

    LocalStoragePrototype.addInList = function (key, value) {
        var list = getList(key);
        if(list.indexOf(value) < 0){
            list.push(value);
        }
        return ls.setItem(key, JSON.stringify(list));
    };

    LocalStoragePrototype.isInList = function (key, value) {
        var list = getList(key);
        return list.indexOf(value) >= 0;
    };

    LocalStoragePrototype.ls = ls;

    return LocalStoragePrototype;
});
